/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PriceListItemRequest } from '../types/PriceListItem';
import type { PriceListItemResponse } from '../types/PriceListItem';

export type PriceListItemsCreateRequest = PriceListItemRequest;
export type PriceListItemsCreateResponse = PriceListItemResponse;

export type PriceListItemsCreateQuery = {};

/**
 * POST /dmx-server/price_list_items/
 *
 * ```yaml
 * operationId: price_list_items_create
 * tags:
 *   - price_list_items
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PriceListItem'
 *     description: ''
 * ```
 */
export const priceListItemsCreateOperation = (rest?: PriceListItemsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/price_list_items/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/price_list_items/' };
  };

/**
 * POST /dmx-server/price_list_items/
 *
 * ```yaml
 * operationId: price_list_items_create
 * tags:
 *   - price_list_items
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PriceListItem'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PriceListItem'
 *     description: ''
 * ```
 */
export const priceListItemsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: PriceListItemsCreateQuery;
  request: PriceListItemRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PriceListItemResponse>> => {
  const operation = priceListItemsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
